import { Outlet } from "react-router-dom";
// components
import { Card, CardContent, Stack, Typography } from "@material-ui/core";

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function LogoOnlyLayout() {
  return (
    <>
      <Outlet />
      <Card>
        <CardContent>
          <Stack spacing={2} direction="row">
            <Typography variant="body1" gutterBottom>
              Version {process.env.REACT_APP_VERSION}
            </Typography>
          </Stack>
        </CardContent>
      </Card>
    </>
  );
}
